<template>
    <div>
        <b-form>
            <div class="animated fadeIn">

            <b-row>
                <b-col>
                    <v-select v-model="selectedCategories" multiple :options="brandDDL" placeholder="Selecionar marcas" label="text" v-if="brandDDL.length > 0"></v-select>
                    <b-input readonly placeholder="Nenhuma marca disponível" v-else></b-input>
                </b-col>
                <b-col md="auto">
                    <b-form-group>
                        <b-button variant="github" class="mr-1 btn-brand" @click="openEditModal(null)"><i class="fa fa-plus"></i><span>Incluir Marca</span></b-button>
                    </b-form-group>
                </b-col>
            </b-row>
                
            <b-row>
                <b-col md="12">
                
                <b-table :items="items"
                    :fields="table.fields" 
                    :select-mode="table.selectMode" 
                    responsive="sm" 
                    primary-key="id" 
                    :tbody-transition-props="table.transProps" 
                    sort-icon-left
                    @row-clicked="rowClicked"
                    per-page="50" 
                    current-page="1" 
                    :busy="table.isBusy" 
                    hover striped>

                    <template #table-busy>
    
                    <div class="text-center text-danger my-2">
    
                        <b-spinner class="align-middle"></b-spinner>
    
                        <strong>Carregando...</strong>
    
                    </div>
                    </template>
                                
                    <!-- Example scoped slot for select state illustrative purposes -->
                    <template #cell(selected)="{ rowSelected }">
                        <template v-if="rowSelected">
                        
                                        <span aria-hidden="true">&check;</span>
                        
                                        <span class="sr-only">Selected</span>
                    </template>
                    <template v-else>
                        <span aria-hidden="true">&nbsp;</span>
                        
                        <span class="sr-only">Not selected</span>
                    </template>
                                </template>

                    
                    <template v-slot:cell(action)="data">
                    <!--<c-switch class="" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" /> -->
                    <b-button size="sm" variant="dark" @click="editDocument(data.item)" class="mr-1 btn-brand"><i class="fa fa-search"></i></b-button>
                    </template>

                    <template v-slot:cell(st)="data">
                        <c-switch class="" color="primary" :checked="data.item.st=='A'" label variant="pill" v-bind="switchLabelIcon" />
                    </template>
                                
                                
                </b-table>
                
                </b-col>
            </b-row>

            </div>
        </b-form>

        <b-modal
            v-model="editModal"
            id="edit-modal"
            centered
            hide-footer
            title="Marca"
            size="lg">
            <b-card>

            </b-card>
        </b-modal>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from "axios";
import vSelect from 'vue-select'

export default {
    name: 'productSelectComponent',
    props: {
        selectedProductType: Object
    },
    components: {
       vSelect
    },
    data: () => {
        return {
            selectedCategories: [],
            brandDDL: [],

            selectedItem: null,
            editModal: false,
            items: [],
            table: {
                isBusy: false,
                fields: [
                    { key: 'name', label: 'Marca', sortable: true },
                    { key: 'action', label: '', sortable: false, thStyle: { width: "40px" } }
                ],
                selectMode: 'single', 
                transProps: {
                    name: 'flip-list'
                }
            }

        }
    },
    methods: {
        rowClicked(item) {
            console.log("Linha clicada")
            this.selectedItem = item
        },
        openEditModal() {
            this.editModal = true
        },
        closeEditModal() {
            this.editModal = false
        },
        async getBrand() {
            var s = this
            var currentUser = this.$store.state.currentUser;
            console.log( this.$store.state.ws_url + "/product/brand/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid )
            await axios.get(
                this.$store.state.ws_url + "/product/brand/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
                s.brandDDL = resp.data.obj
            }).catch(function(error) {
                console.log(error)
            })         
        }
    },
    mounted: function() {
        this.getBrand()
    }
}
</script>